import React from 'react';
import PropTypes from 'prop-types';
import {Button, Text} from 'rebass'
import {Backdrop, InlineBlock, Overlay} from "reakit";
// import {DesktopBox, MobileBox} from "../Base";
// import IosArrowForward from "react-ionicons/lib/IosArrowForward";
import styled from "styled-components";

const StyledOverlay = styled(Overlay)`
	min-width: 150px;
	min-height: 110px;
	@media(max-width: 700px){
	min-width: 90vw;
	}
`

const ConfirmSetPanic = props => {
	const { handleConfirm, visible, toggle} = props;

	return (
		<Overlay.Container>
			{overlay => (
				<InlineBlock>
					<Backdrop fade use={Overlay.Hide} {...overlay} visible={visible} onClick={toggle} zIndex={1100}/>
					<StyledOverlay fade slide {...overlay} visible={visible} zIndex={1200} >
						<Text>Would you like to Press this Panic Button?</Text>
						<Button variant={'approve'} p={1} m={1} bg={'red'} onClick={() => {
							handleConfirm()
							toggle()
						}}>Yes</Button>
						<Button variant={'approve'} p={1} m={1} bg={'green'} onClick={() => {
							toggle()
						}}>No</Button>
					</StyledOverlay>
				</InlineBlock>
			)}
		</Overlay.Container>
	);
};

ConfirmSetPanic.propTypes = {
	handleConfirm: PropTypes.func,
	toggle: PropTypes.func,
	visible: PropTypes.bool,
	noButton: PropTypes.bool
};

ConfirmSetPanic.defaultProps = {
	handleConfirm: () => console.log('clicked confirm discard and save'),
	visible: false,
	noButton: false
};

export default ConfirmSetPanic;
